import { http } from "@/lib/api";

const d = (p) => p.then((r) => r.data);
export const cr = {
  meta: () => d(http.get("/cricket/meta")),
  slugCheck: (slug) => d(http.get("/cricket/slug-check", { params: { slug } })),
  list: () => d(http.get("/cricket/tournaments")),
  create: (b) => d(http.post("/cricket/tournaments", b)),
  get: (id) => d(http.get(`/cricket/tournaments/${id}`)),
  update: (id, b) => d(http.put(`/cricket/tournaments/${id}`, b)),
  remove: (id) => d(http.delete(`/cricket/tournaments/${id}`)),
  members: (id, members) => d(http.put(`/cricket/tournaments/${id}/members`, { members })),
  audit: (id) => d(http.get(`/cricket/tournaments/${id}/audit`)),
  teams: (id) => d(http.get(`/cricket/tournaments/${id}/teams`)),
  addTeam: (id, b) => d(http.post(`/cricket/tournaments/${id}/teams`, b)),
  saveTeam: (tid, b) => d(http.put(`/cricket/teams/${tid}`, b)),
  delTeam: (tid) => d(http.delete(`/cricket/teams/${tid}`)),
  players: (params) => d(http.get("/cricket/players", { params })),
  addPlayer: (b) => d(http.post("/cricket/players", b)),
  savePlayer: (id, b) => d(http.put(`/cricket/players/${id}`, b)),
  deletePlayer: (id) => d(http.delete(`/cricket/players/${id}`)),
  importPlayers: (players) => d(http.post("/cricket/players/import", { players })),
  playerStats: (pid, tid, match_id) => d(http.get(`/cricket/players/${pid}/stats`, { params: { tid, ...(match_id ? { match_id } : {}) } })),
  matches: (id) => d(http.get(`/cricket/tournaments/${id}/matches`)),
  addMatch: (id, b) => d(http.post(`/cricket/tournaments/${id}/matches`, b)),
  saveMatch: (mid, b) => d(http.put(`/cricket/matches/${mid}`, b)),
  delMatch: (mid) => d(http.delete(`/cricket/matches/${mid}`)),
  state: (mid) => d(http.get(`/cricket/matches/${mid}/state`)),
  event: (mid, type, data, expected_seq) => d(http.post(`/cricket/matches/${mid}/events`, { type, data, expected_seq })),
  fix: (mid, seq, data, expected_seq) => d(http.put(`/cricket/matches/${mid}/events/${seq}`, { data, expected_seq })),
  undo: (mid, expected_seq) => d(http.post(`/cricket/matches/${mid}/undo`, { expected_seq })),
  publish: (mid) => d(http.post(`/cricket/matches/${mid}/publish`)),
  onair: (id, b) => d(http.put(`/cricket/tournaments/${id}/onair`, b)),
  provider: (id, enabled) => d(http.put(`/cricket/tournaments/${id}/provider`, { enabled })),
  providerLive: (id) => d(http.get(`/cricket/tournaments/${id}/provider/live`)),
  upload: (file) => { const fd = new FormData(); fd.append("file", file); return d(http.post("/cricket/assets", fd)); },
  codeList: (tid) => d(http.get(`/cricket/tournaments/${tid}/code-graphics`)),
  codeCreate: (tid, b) => d(http.post(`/cricket/tournaments/${tid}/code-graphics`, b)),
  codeSave: (gid, b) => d(http.put(`/cricket/code-graphics/${gid}`, b)),
  codeVersion: (gid, note) => d(http.post(`/cricket/code-graphics/${gid}/versions`, { note })),
  codeRestore: (gid, v) => d(http.post(`/cricket/code-graphics/${gid}/restore`, { v })),
  codeDelete: (gid) => d(http.delete(`/cricket/code-graphics/${gid}`)),
  media: (tid) => d(http.get(`/cricket/tournaments/${tid}/media`)),
  mediaUpload: (tid, file, category, team_id, onUploadProgress) => { const f = new FormData(); f.append("file", file); f.append("category", category || "other"); f.append("team_id", team_id || ""); return d(http.post(`/cricket/tournaments/${tid}/media`, f, { onUploadProgress })); },
  mediaLink: (tid, b) => d(http.post(`/cricket/tournaments/${tid}/media/link`, b)),
  mediaPatch: (id, b) => d(http.patch(`/cricket/media/${id}`, b)),
  mediaDelete: (id) => d(http.delete(`/cricket/media/${id}`)),
  sheet: (tid) => d(http.get(`/cricket/tournaments/${tid}/sheet`)),
  sheetSync: (tid, b) => d(http.post(`/cricket/tournaments/${tid}/sheet/sync`, b)),
  sheetEdit: (tid, key, b) => d(http.put(`/cricket/tournaments/${tid}/sheet/${encodeURIComponent(key)}`, b)),
  sheetDelete: (tid, key) => d(http.delete(`/cricket/tournaments/${tid}/sheet/${encodeURIComponent(key)}`)),
  sheetAddRow: (tid, player_id) => d(http.post(`/cricket/tournaments/${tid}/sheet/rows`, { player_id })),
  pubT: (slug) => d(http.get(`/cricket/public/t/${slug}`)),
  pubMatch: (slug, mid) => d(http.get(`/cricket/public/t/${slug}/match/${mid}`)),
  pubOutput: (slug, k) => d(http.get(`/cricket/public/t/${slug}/output`, { params: k ? { k } : {} })),
};
export const crErr = (e, fb = "Something went wrong") => { const v = e?.response?.data?.detail; return typeof v === "string" ? v : Array.isArray(v) ? v.map((x) => x.msg).join(", ") : fb; };
